import { createSelector } from '@ngrx/store';
import { selectBasicDataState } from './main.selector';
import { IBasicDataState } from '../reducers';

export const selectAdditionalSettings = createSelector(
  selectBasicDataState,
  (basicDataState: IBasicDataState) => basicDataState.additionalSettings,
);
